package br.com.texeratx.boardgametimeapp.core.storage

import br.com.texeratx.boardgametimeapp.data.model.login.UserSession
import kotlinx.browser.localStorage
import kotlinx.serialization.json.Json

class TokenStorageJs : TokenStorage {

    private val json = Json { ignoreUnknownKeys = true }

    override suspend fun saveSession(session: UserSession) {
        localStorage.setItem("session_json", json.encodeToString(UserSession.serializer(), session))
    }

    override suspend fun getSession(): UserSession? {
        val raw = localStorage.getItem("session_json") ?: return null
        return runCatching { json.decodeFromString(UserSession.serializer(), raw) }.getOrNull()
    }

    override suspend fun clear() {
        localStorage.removeItem("session_json")
    }
}

actual fun provideTokenStorage(): TokenStorage = TokenStorageJs()
